export default __webpack_public_path__ + "static/media/values1.5b18888e.png";